module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-BoldExtended-2253e6ccde3df084eef28690ab46d003.ttf";